// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"d28b5bf7","477":"d68d4b2d"}[chunkId] + ".chunk.js";
};